import * as yup from 'yup';
import { labels, validationMessages } from '@srichaitra/constants';

/**
 * Reusable field rules.
 *
 * These deliberately mirror what the backend enforces (see
 * NodeJS/src/actions/authActions.js). The server is the authority — client-side
 * validation is a courtesy that saves a round trip, never a security control —
 * but matching the bounds means a user is told about a problem before they
 * submit rather than after, and never sees a rejection for a rule the form
 * appeared to accept.
 *
 * If a bound changes on the server, change it here too. The comment beside each
 * one names the backend rule it shadows.
 */

/** Backend: USER_ID_PATTERN, /^[A-Za-z0-9._-]{3,64}$/ */
export const USER_ID_PATTERN = /^[A-Za-z0-9._-]+$/;
export const USER_ID_MIN = 3;
export const USER_ID_MAX = 64;

/** Backend: "password" must be between 8 and 200 characters */
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 200;

export const userIdRule = yup
  .string()
  .trim()
  .required(validationMessages.required(labels.login.userId))
  .min(USER_ID_MIN, validationMessages.minLength(labels.login.userId, USER_ID_MIN))
  .max(USER_ID_MAX, validationMessages.maxLength(labels.login.userId, USER_ID_MAX))
  .matches(USER_ID_PATTERN, validationMessages.pattern(labels.login.userId));

export const passwordRule = yup
  .string()
  .required(validationMessages.required(labels.login.password))
  .min(PASSWORD_MIN, validationMessages.minLength(labels.login.password, PASSWORD_MIN))
  .max(PASSWORD_MAX, validationMessages.maxLength(labels.login.password, PASSWORD_MAX));

export const emailRule = yup.string().trim().email(validationMessages.email());
